export enum BUTTON_TYPE {
  DEFAULT = 'DEFAULT',
  SUBMIT = 'SUBMIT',
}
